import { ifCanPushDatalayer, pageTypeIncludes } from "./utils/utils.dataLayer.common";
import categorizeMarketoFormSubmission from "./form-categorize-submission.common";

//UCS006
const dataLayerFormRoiCalculator = (userStatus, userEmail, marketoIDF) => {
    ifCanPushDatalayer({
        then: () => {
            const form = document.querySelector("[data-form-id]");
            const formID = form ? form.dataset.formId : "";

            if ((formID === "roi_calculator" && pageTypeIncludes("calculator"))) {
                if (userEmail) {
                    const hashParams = new URLSearchParams(location.hash.replace('#', ''));
                    const useCase = hashParams.get('use-case') ?? '';
                    categorizeMarketoFormSubmission({
                        userEmail,
                        userStatus,
                        leadType: "roi calculator",
                        marketoIDF,
                        useCase
                    });
                }
            }
        },
    });
};

export default dataLayerFormRoiCalculator;
